import React, {PureComponent} from 'react';
import {FormattedMessage} from "react-intl";

export default class WebsiteButton extends PureComponent {
  render() {
    return (
      <button className="materials-button materials-button--home" onClick={this.props.onClick}>
        <span className="materials-button__text"><FormattedMessage id="websiteButton.website"/></span>
      </button>
    );
  }
}
